import React from "react";
import classNames from "classnames";

import BEM from "./TinyButton.module.scss";

export const TinyButton = (props) => {
  const Tag = props.tag === "a" ? "a" : "button";

  return (
    <Tag
      {...props}
      className={classNames({
        [BEM.BLOCK]: true,
        [props.className]: !!props.className,
      })}
      type="button"
    >
      {props.children}
    </Tag>
  );
};
